module.exports = __webpack_public_path__ + "img/ingredienten-laab-kai.a9c33965.jpg";